import { UserCheck } from 'lucide-react';
import { PersonaVerification } from './PersonaVerification';
import { PersonaInquiryType } from '@sandtech-hub-monorepo/ehub-client';
import { Application } from '../../types';

interface IDVerificationModalProps {
  close: () => void;
  application: Application;
}

export const IDVerificationModal = ({
  close,
  application,
}: IDVerificationModalProps) => {
  return (
    <PersonaVerification
      icon={<UserCheck height="48" width="48" />}
      title="Identity Verification"
      description="Please follow the instructions to verify your identity."
      programApplicationId={application.id}
      inquiryType={PersonaInquiryType.Identity}
      close={close}
    />
  );
};
